import React from 'react';

import { Table, Input, Button, Space } from 'antd';
import Highlighter from 'react-highlight-words';
import { SearchOutlined } from '@ant-design/icons';

class TabelaFormandos extends React.Component {

  state = {
    searchedColumn: {}
  }

  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : '',
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: text =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: '' });
  };

  render () {
    const columns = [
      {
        title: 'Nome',
        key: 'nome',
        dataIndex: 'nome',
        sorter: (a, b) => a.nome.localeCompare(b.nome, 'pt-BR', { sensitivity: 'base' }),
        defaultSortOrder: 'ascend',
        ...this.getColumnSearchProps('nome'),
      },
      {
        title: 'E-mail',
        key: 'email',
        dataIndex: 'email',
        ...this.getColumnSearchProps('email'),
      },
      {
        title: 'Celular',
        key: 'celular',
        dataIndex: 'celular',
        ...this.getColumnSearchProps('celular'),
      },
      {
        title: 'CPF',
        key: 'documento',
        dataIndex: 'documento',
        ...this.getColumnSearchProps('documento'),
        render: (documento) => documento ? documento.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4') : '-'
      },
      {
        title: 'Data de Nascimento',
        key: 'dataNascimento',
        dataIndex: 'dataNascimento',
        ...this.getColumnSearchProps('dataNascimento'),
        render: (dataNascimento) => {
          if (!dataNascimento || dataNascimento === '') return '-';

          // Trata string
          if (typeof dataNascimento === 'string') {
            // Remove espaços extras
            dataNascimento = dataNascimento.trim();

            // Formato YYYY-MM-DD ou YYYY/MM/DD (ISO)
            if (dataNascimento.match(/^\d{4}[-\/]\d{2}[-\/]\d{2}$/)) {
              const partes = dataNascimento.split(/[-\/]/);
              const ano = partes[0];
              const mes = partes[1];
              const dia = partes[2];
              return `${dia.padStart(2, '0')}/${mes.padStart(2, '0')}/${ano}`;
            }

            // Formato DD-MM-YYYY ou DD/MM/YYYY (já no formato correto)
            if (dataNascimento.match(/^\d{2}[-\/]\d{2}[-\/]\d{4}$/)) {
              return dataNascimento.replace(/-/g, '/');
            }

            // Formato DD-MM-YY ou DD/MM/YY (ano com 2 dígitos)
            if (dataNascimento.match(/^\d{2}[-\/]\d{2}[-\/]\d{2}$/)) {
              const partes = dataNascimento.split(/[-\/]/);
              const dia = partes[0];
              const mes = partes[1];
              const ano = '20' + partes[2]; // Assume 20XX
              return `${dia}/${mes}/${ano}`;
            }
          }

          // Fallback: retorna como está
          return dataNascimento;
        }
      },
      {
        title: 'Curso',
        key: 'curso',
        dataIndex: 'curso',
        ...this.getColumnSearchProps('curso'),
      },
      {
        title: 'Ações',
        key: 'action',
        render: (record) => (
          <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
            <button type="button" className="btn btn-link" onClick={() => this.props.editarFormando(record)}><i className="fas fa-edit"></i> Editar</button>
            { record.usuario ? <button type="button" className="btn btn-link" onClick={() => this.props.reenviarEmail(record)}><i className="fas fa-envelope"></i> Reenviar acesso</button> : null }
            { this.props.isAdmin ? <button type="button" className="btn btn-link" onClick={() => this.props.excluirFormando(record.id)}><i className="fas fa-trash"></i> Excluir</button> : null }
          </div>
        ),
      }
    ];
    return (
      <div className="table-responsive">
        <Table columns={columns} dataSource={this.props.data} rowKey={record => record.id} bordered />
      </div>
    );
  }
}

export default TabelaFormandos;
